import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';
import { unpack, pack } from 'msgpackr';
import stringify from '../utils/stableStringify';
import AntCondition from '../utils/AntCondition';
import AntGrid from './AntPOSVoucherGrid';
import AntTabs from './AntPOSTabs';

export default forwardRef(function (props, ref) {
    const [shouldRender, setShouldRender] = useState(1);

    const isRender = useMemo(() => shouldRender + (props.shouldRender ? props.shouldRender : 1), [props.shouldRender, shouldRender]);

    const forceRender = useCallback(() => {
        setShouldRender((v) => v + 1);
    }, []);

    const initMainTabs = useCallback(() => {
        var tabs = [];

        if (props.tabs instanceof Array) {
            tabs = props.tabs.filter((tab) => {
                return AntCondition.isVisible(props.formData, tab);
            });
        }
        return tabs;
    }, [props.formData]);

    const mainTabs = useMemo(() => initMainTabs(), [props.formData]);

    const tabHeaders = useRef([]);
    const tabFooters = useRef([]);
    const tabGrids = useRef([]);

    const isGridAllowQuery = useCallback(
        (tabGrid) => {
            if (
                !tabGrid ||
                !tabGrid.FKField ||
                (!tabGrid.parentIDField && !props.formData.code) ||
                (tabGrid.parentIDField && (!props.formData || !props.formData[tabGrid.parentIDField]))
            ) {
                return false;
            }

            return true;
        },
        [props.formData]
    );

    const getFKData = useCallback(
        (tabGrid) => {
            // if (!tabGrid || !tabGrid.FKField || !props.formData.code) {
            if (
                !tabGrid ||
                !tabGrid.FKField ||
                (!tabGrid.parentIDField && !props.formData.code) ||
                (tabGrid.parentIDField && (!props.formData || !props.formData[tabGrid.parentIDField]))
            ) {
                return {
                    // notAllowQuery:true
                };
            }

            var childValue = tabGrid.parentIDField ? (props.formData ? props.formData[tabGrid.parentIDField] : undefined) : props.formData.code;

            return {
                [tabGrid.FKField]: childValue
            };
        },
        [props.formData]
    );

    const onEdited = useCallback(
        (tabName, data) => {
            let tab = props.tabs.find((tab) => tab.name === tabName || (!tab.name && String(i) === tabName));
            if (tab && tab.onEdited) tab.onEdited(data);

            if (props.onAfterAction) props.onAfterAction(data);
        },
        [props.onEdited, props.tabs, props.onAfterAction]
    );

    const onRenderTab = useCallback(
        (eTab) => {
            if (!eTab) return <div></div>;

            let tabName = eTab.name;

            if (mainTabs.length <= 0 || props.tabs instanceof Array === false || props.tabs.length <= 0) return <div></div>;

            let tab = props.tabs.find((tab) => tab.name === tabName || (!tab.name && String(i) === tabName));
            if (!tab) return <div></div>;

            let isVisible = AntCondition.isVisible(props.formData, tab);
            if (!isVisible) return <div></div>;

            let tabHeader = tab.header;
            let tabFooter = tab.footer;
            if (tabHeader) tabHeader = JSON.parse(stringify(tabHeader));
            if (tabFooter) tabFooter = JSON.parse(stringify(tabFooter));

            let tabGrid = tab.grid;
            let tabGridRawCols = tabGrid && tabGrid.columns instanceof Array ? tabGrid.columns : [];
            let tabGridCols = tabGrid && tabGrid.columns instanceof Array ? tabGrid.columns : [];
            let tabGridActions = tabGrid && tabGrid.actionItems instanceof Array ? tabGrid.actionItems : [];
            tabGridRawCols = JSON.parse(stringify(tabGridRawCols));
            tabGridCols = JSON.parse(stringify(tabGridCols));
            tabGridActions = JSON.parse(stringify(tabGridActions));

            let isVisibleTabHeader = false;
            let isVisibleTabGrid = false;
            let isVisibleTabFooter = false;

            let header = null;
            let footer = null;
            let grid = null;

            let isCanAdd = props.formData && props.formData.edit && props.formData.edit.isEditable && props.formData.edit.withChildren;

            if (isCanAdd && typeof props.formData.edit.withChildren === 'object' && props.formData.edit.withChildren.canAdd !== undefined)
                isCanAdd = Boolean(props.formData.edit.withChildren.canAdd);
            else if (isCanAdd && props.formData.edit.withChildren instanceof Array && tabGrid) {
                let gridTableName = tabGrid && tabGrid.table ? tabGrid.table : tabGrid.API ? tabGrid.API.entityName : props.table;
                let found = gridTableName ? props.formData.edit.withChildren.find((f) => f.table === gridTableName) : false;
                isCanAdd = found ? Boolean(found.canAdd) : false;
            }

            let isCanEdit = props.formData && props.formData.edit && props.formData.edit.isEditable && props.formData.edit.withChildren;
            if (isCanEdit && typeof props.formData.edit.withChildren === 'object' && props.formData.edit.withChildren.canEdit !== undefined)
                isCanEdit = Boolean(props.formData.edit.withChildren.canEdit);
            else if (isCanEdit && props.formData.edit.withChildren instanceof Array && tabGrid) {
                let gridTableName = tabGrid && tabGrid.table ? tabGrid.table : tabGrid.API ? tabGrid.API.entityName : props.table;
                let found = gridTableName ? props.formData.edit.withChildren.find((f) => f.table === gridTableName) : false;
                isCanEdit = found ? Boolean(found.canEdit) : false;
            }

            let isCanDelete = props.formData && props.formData.edit && props.formData.edit.isEditable && props.formData.edit.withChildren;
            if (isCanDelete && typeof props.formData.edit.withChildren === 'object' && props.formData.edit.withChildren.canDelete !== undefined)
                isCanDelete = Boolean(props.formData.edit.withChildren.canDelete);
            else if (isCanDelete && props.formData.edit.withChildren instanceof Array && tabGrid) {
                let gridTableName = tabGrid && tabGrid.table ? tabGrid.table : tabGrid.API ? tabGrid.API.entityName : props.table;
                let found = gridTableName ? props.formData.edit.withChildren.find((f) => f.table === gridTableName) : false;
                isCanDelete = found ? Boolean(found.canDelete) : false;
            }

            tabGridActions = tabGridActions.filter((a) => {
                let isVisible = AntCondition.isVisible(props.formData, a);

                if (
                    isVisible &&
                    a.visibleOnMain &&
                    props.formData &&
                    Object.keys(props.formData).length > 0 &&
                    (props.formData.id || props.formData.code)
                ) {
                    let vObj = a.visibleOnMain;
                    if (a.visibleOnMain instanceof Array) {
                        vObj = a.visibleOnMain.find(
                            (v) =>
                                v.table === props.formTable ||
                                (v.table instanceof Array && v.table.includes(props.formTable)) ||
                                (v.tables instanceof Array && v.tables.includes(props.formTable))
                        );

                        if (vObj) vObj = vObj.value;
                    }
                    if (vObj)
                        isVisible = AntCondition.isVisible(props.formData, {
                            visible: vObj
                        });
                }
                return isVisible;
            });

            tabGridActions = tabGridActions.map((gr) => {
                if (gr.items instanceof Array) {
                    gr.items = gr.items.filter((a) => {
                        let isVisible = AntCondition.isVisible(props.formData, a);

                        if (
                            isVisible &&
                            a.visibleOnMain &&
                            props.formData &&
                            Object.keys(props.formData).length > 0 &&
                            (props.formData.id || props.formData.code)
                        ) {
                            let vObj = a.visibleOnMain;
                            if (a.visibleOnMain instanceof Array) {
                                vObj = a.visibleOnMain.find(
                                    (v) =>
                                        v.table === props.formTable ||
                                        (v.table instanceof Array && v.table.includes(props.formTable)) ||
                                        (v.tables instanceof Array && v.tables.includes(props.formTable))
                                );

                                if (vObj) vObj = vObj.value;
                            }
                            if (vObj)
                                isVisible = AntCondition.isVisible(props.formData, {
                                    visible: vObj
                                });
                        }
                        return isVisible;
                    });
                }
                return gr;
            });

            tabGridActions = tabGridActions.filter((a) => {
                let isActionVisible = true;
                if (a.equivalentParentActions instanceof Array) {
                    isActionVisible = false;
                    if (props.formData?.actions?.some((k) => a.equivalentParentActions.includes(k.name) && k.visible)) {
                        isActionVisible = true;
                    }
                }
                if (!isActionVisible) return false;

                return (
                    a.equivalentActions instanceof Array === false ||
                    (a.equivalentActions.includes('add') && isCanAdd) ||
                    (a.equivalentActions.includes('edit') && isCanEdit) ||
                    (a.equivalentActions.includes('delete') && isCanDelete)
                );
            });

            let isCanImportCreate = Boolean(
                tabGrid &&
                    (tabGrid.showImport || isCanAdd) &&
                    tabGrid.import !== undefined &&
                    (tabGrid.import.createable !== undefined ? tabGrid.import.createable : false)
            );
            let isCanImportUpdate = Boolean(
                tabGrid &&
                    (tabGrid.showImport || isCanEdit) &&
                    tabGrid.import !== undefined &&
                    (tabGrid.import.updateable !== undefined ? tabGrid.import.updateable : false)
            );

            let isCanImport = isCanImportCreate || isCanImportUpdate;

            let showAdd =
                props.disabled !== true && isCanAdd && tabGrid && tabGrid.add !== undefined && AntCondition.isVisible(props.formData, tabGrid.add);

            let showEdit =
                props.disabled !== true && isCanEdit && tabGrid && tabGrid.edit !== undefined && AntCondition.isVisible(props.formData, tabGrid.edit);
            let showDelete =
                props.disabled !== true &&
                isCanDelete &&
                tabGrid &&
                tabGrid.delete !== undefined &&
                AntCondition.isVisible(props.formData, tabGrid.delete);
            let showImport =
                props.disabled !== true &&
                isCanImport &&
                tabGrid &&
                tabGrid.import !== undefined &&
                AntCondition.isVisible(props.formData, tabGrid.import);

            let isCanSelect = props.disabled !== true && (showEdit || showDelete);

            if (tabHeader) {
                let headerName = tabHeader.name ? tabHeader.name : tabName;
                header = tabHeaders.current.find((r) => r.name === headerName);
                if (!header) {
                    header = {
                        tabName: tabName,
                        name: headerName,
                        props: tabHeader,
                        tabProps: tab,
                        ref: React.createRef()
                    };
                    tabHeaders.current.push(header);
                }
            }

            if (tabFooter) {
                let footerName = tabFooter.name ? tabFooter.name : tabName;
                footer = tabFooters.current.find((r) => r.name === footerName);
                if (!footer) {
                    footer = {
                        tabName: tabName,
                        name: footerName,
                        props: tabFooter,
                        tabProps: tab,
                        ref: React.createRef()
                    };
                    tabFooters.current.push(footer);
                }
            }
            let gridName = null;
            if (tabGrid) {
                gridName = String(tabGrid.name ? tabGrid.name : tabName);
                grid = tabGrids.current.find((r) => r.name === gridName);
                if (!grid) {
                    grid = {
                        tabName: tabName,
                        name: gridName,
                        props: tabGrid,
                        tabProps: tab,
                        ref: React.createRef()
                    };
                    tabGrids.current.push(grid);
                }

                tabGrid = grid.props;

                tabGridCols = tabGridCols.slice().filter((col) => {
                    return AntCondition.isRender(props.formData, col);
                });

                tabGridCols.forEach((col) => {
                    // if (typeof col.visible !== 'object' || col.visible.type !== 'action' || !col.visible.field)
                    col.rawConfig = JSON.parse(stringify(col));
                    col.visible = AntCondition.isVisible(props.formData, col);
                    col.editable = isCanEdit && AntCondition.isEditable(props.formData, col);
                });
            }

            isVisibleTabHeader = tabHeader && AntCondition.isVisible(props.formData, tabHeader);
            isVisibleTabFooter = tabFooter && AntCondition.isVisible(props.formData, tabFooter);
            isVisibleTabGrid = tabGrid && AntCondition.isVisible(props.formData, tabGrid);

            let searchFields = [];

            if (tabGrid && tabGrid.FKField) searchFields.push(tabGrid.FKField);

            if (tabGrid && tabGrid.searchFields instanceof Array)
                tabGrid.searchFields.forEach((f) => {
                    searchFields.push(f);
                });
            if (tabGrid && typeof tabGrid.searchConditions === 'object' && tabGrid.searchConditions !== null) {
                Object.keys(tabGrid.searchConditions).map((f) => {
                    searchFields.push(f);
                });
            }
            let showScanBarcode = tabGrid && tabGrid.showScanBarcode !== undefined ? tabGrid.showScanBarcode : false;
            if (tabGrid && tabGrid.showScanBarcode && typeof tabGrid.showScanBarcode === 'object')
                showScanBarcode = AntCondition.isValid(props.formData, tabGrid.showScanBarcode);

            // console.log('ant-log-window.innerHeight : ',window.innerHeight);

            return (
                <React.Fragment>
                    <div
                        style={{
                            display: 'flex',
                            height: '100%',
                            // maxHeight: 0.44 * window.innerHeight,
                            overflowY: 'auto'
                        }}
                    >
                        {isVisibleTabGrid && (
                            <React.Fragment>
                                <AntGrid
                                    ref={grid.ref}
                                    API={grid.props.API ? grid.props.API : props.API}
                                    parentTable={props.formTable}
                                    parentData={props.formData}
                                    tabName={tab.name}
                                    settingsKey={tabGrid && tabGrid.settingsKey ? tabGrid.settingsKey : undefined}
                                    parentFK={getFKData(tabGrid)}
                                    FKField={tabGrid && tabGrid.FKField ? tabGrid.FKField : undefined}
                                    parentIDField={tabGrid && tabGrid.parentIDField ? tabGrid.parentIDField : 'code'}
                                    url={tabGrid.url}
                                    table={tabGrid && tabGrid.table ? tabGrid.table : tabGrid.API ? tabGrid.API.entityName : props.table}
                                    // height={tabGrid.height !== undefined ? tabGrid.height : props.tabContentHeight !== undefined ? props.tabContentHeight : 'inherit'}
                                    // height={'100%'}
                                    // height={0.55*window.innerHeight}
                                    cellStyles={tabGrid ? tabGrid.cellStyles : undefined}
                                    rowStyles={tabGrid ? tabGrid.rowStyles : undefined}
                                    flashConds={tabGrid ? tabGrid.flashConds : undefined}
                                    showRowActions={tabGrid ? tabGrid.showRowActions : undefined}
                                    rowActionPack={tabGrid ? tabGrid.rowActionPack : undefined}
                                    rowActions={tabGrid ? tabGrid.rowActions : undefined}
                                    rowActionWidth={tabGrid ? tabGrid.rowActionWidth : undefined}
                                    afterRowAction={props.onAfterAction}
                                    keyExpr={'id'}
                                    // remotePaging={tabGrid.remotePaging !== undefined ? tabGrid.remotePaging : false}
                                    remotePaging={false}
                                    // remotePaging={true}
                                    allowedPageSizes={tabGrid.allowedPageSizes !== undefined ? tabGrid.allowedPageSizes : 5}
                                    defaultPageSize={tabGrid.defaultPageSize}
                                    showPageSizeSelector={false}
                                    pagerHideable={true}
                                    sortable={tabGrid.sortable !== undefined ? tabGrid.sortable : false}
                                    selectable={isCanSelect}
                                    allowEdit={props.disabled ? false : isCanEdit && (tabGrid.allowEdit !== undefined ? tabGrid.allowEdit : true)}
                                    allowAutoUpdate={
                                        props.disabled ? false : isCanEdit && (tabGrid.allowAutoUpdate !== undefined ? tabGrid.allowAutoUpdate : true)
                                    }
                                    focusStateEnabled={false}
                                    fields={tabGrid.fields}
                                    columns={tabGridCols}
                                    rawColumns={tabGridRawCols}
                                    keyboardNavigation={tabGrid.keyboardNavigation}
                                    actionItems={tabGridActions}
                                    onAction={tabGrid.onAction}
                                    onRowAction={tabGrid.onRowAction}
                                    ordering={tabGrid.ordering}
                                    searchConditions={tabGrid.searchConditions}
                                    searchFields={searchFields.length > 0 ? searchFields : undefined}
                                    searchConditionsRequired={true}
                                    isAllowQuery={() => isGridAllowQuery(tabGrid)}
                                    onDataSourceEdited={props.onDataSourceEdited}
                                    showRefresh={tabGrid.showRefresh !== undefined ? tabGrid.showRefresh : true}
                                    showActionBar={tabGrid.showActionBar}
                                    edit={tabGrid.edit}
                                    add={tabGrid.add}
                                    delete={tabGrid.delete}
                                    import={tabGrid.import}
                                    showEdit={props.disabled ? false : Boolean(showEdit)}
                                    showDelete={props.disabled ? false : Boolean(showDelete)}
                                    showAdd={props.disabled ? false : Boolean(showAdd)}
                                    showImport={props.disabled ? false : Boolean(showImport)}
                                    showDownload={tabGrid.showDownload}
                                    showDetail={tabGrid.showDetail}
                                    showIndex={tabGrid.showIndex}
                                    showSelectAll={tabGrid.showSelectAll !== undefined ? tabGrid.showSelectAll : true}
                                    showFilterBySelected={tabGrid.showFilterBySelected !== undefined ? tabGrid.showFilterBySelected : false}
                                    showFieldChooser={tabGrid.showFieldChooser !== undefined ? tabGrid.showFieldChooser : true}
                                    showSearchBar={tabGrid.showSearchBar !== undefined ? tabGrid.showSearchBar : false}
                                    autoFocusSearchBar={tabGrid.autoFocusSearchBar}
                                    showScanBarcode={!props.disabled && isCanAdd && showScanBarcode}
                                    searchBarWidth={tabGrid.searchBarWidth}
                                    onRowDblClick={(e) => {
                                        if (props.onRowDblClick) props.onRowDblClick(e, tabName, tabGrid);
                                    }}
                                    onBarcodeScanned={props.onBarcodeScanned}
                                    onDeleted={props.onAfterAction}
                                    onAdded={props.onAfterAction}
                                    onEdited={(e) => onEdited(tabName, e)}
                                    onImported={props.onAfterAction}
                                    canImportCreate={isCanImportCreate}
                                    canImportUpdate={isCanImportUpdate}
                                    showDetailPosition={'right'}
                                    searchCategories1={tabGrid.searchCategories1}
                                    searchCategories2={tabGrid.searchCategories2}
                                    searchCategories3={tabGrid.searchCategories3}
                                    searchCategories4={tabGrid.searchCategories4}
                                    searchCategories5={tabGrid.searchCategories5}
                                    searchCategories6={tabGrid.searchCategories6}
                                    searchCategories7={tabGrid.searchCategories7}
                                    searchCategories8={tabGrid.searchCategories8}
                                    searchCategories9={tabGrid.searchCategories9}
                                    searchCategories10={tabGrid.searchCategories10}
                                    byPassCachingStates={tabGrid.byPassCachingStates !== undefined ? tabGrid.byPassCachingStates : true}
                                />
                            </React.Fragment>
                        )}
                    </div>
                </React.Fragment>
            );
        },
        [
            props.tabContentHeight,
            props.formData,
            props.tabs,
            onEdited,
            mainTabs,
            props.shouldRender,
            props.onRowDblClick,
            getFKData,
            shouldRender,
            isRender
        ]
    );

    const validate = useCallback(async () => {
        var isOK = true;

        for (let i = 0; i < tabHeaders.current.length; i++) {
            const header = tabHeaders.current[i];
            if (header && header.ref && header.ref.current) {
                var isValid = await header.ref.current.validate();
                if (!isValid) isOK = false;
            }
        }

        for (let i = 0; i < tabFooters.current.length; i++) {
            const footer = tabFooters.current[i];
            if (footer && footer.ref && footer.ref.current) {
                var isValid = await footer.ref.current.validate();
                if (!isValid) isOK = false;
            }
        }

        return isOK;
    }, []);

    const reloadGrid = useCallback((name) => {
        let grid = tabGrids.current.find((r) => !name || r.name === name);
        if (grid && grid.ref && grid.ref.current) {
            grid.ref.current.refresh();
        }
    }, []);

    const reload = useCallback((opts) => {
        tabGrids.current.forEach((grid) => grid?.ref?.current?.refresh?.(opts));
    }, []);

    const replaceGridRows = useCallback(async (name, rows) => {
        const target = tabGrids.current.find((grid) => !name || grid.name === name);
        if (!target?.ref?.current?.replaceRows || !(rows instanceof Array)) return false;
        return await target.ref.current.replaceRows(rows);
    }, []);

    useImperativeHandle(ref, () => ({
        validate: validate,
        forceRender: forceRender,
        reloadGrid: reloadGrid,
        replaceGridRows: replaceGridRows,
        reload: reload
    }));

    // useEffect(() => {
    //     forceRender();
    // }, [props.formData]);

    useEffect(() => {
        return () => {
            for (let i = 0; i < tabHeaders.current.length; i++) {
                delete tabHeaders[i];
            }
            for (let i = 0; i < tabFooters.current.length; i++) {
                delete tabFooters[i];
            }
            for (let i = 0; i < tabGrids.current.length; i++) {
                delete tabGrids[i];
            }

            delete tabHeaders.current;
            delete tabFooters.current;
            delete tabGrids.current;
            tabHeaders.current = null;
            tabFooters.current = null;
            tabGrids.current = null;
        };
    }, []);

    return (
        <React.Fragment>
            {/* {isRender && ( */}
            <AntTabs
                tabs={mainTabs}
                shouldRender={isRender}
                rawTabs={props.tabs}
                formData={props.formData}
                tabStyle={props.tabStyle}
                // height={props.tabHeight ? props.tabHeight : '100%'}
                onRenderTabContent={onRenderTab}
                autoHideTitle={props.autoHideTitle !== undefined ? props.autoHideTitle : true}
                // animationDuration={330}
                autoExpandAll={props.autoExpandAll !== undefined ? props.autoExpandAll : true}
                groupCollapsible={props.groupCollapsible}
                groupExpandMultiple={props.groupExpandMultiple !== undefined ? props.groupExpandMultiple : false}
                visible={props.visible}
                lazyLoading={false}
            />
            {/* )} */}
        </React.Fragment>
    );
});
